import type { RedirectionRoute } from "./router-redirections.type";

import { useLocation } from "react-router";

import { getRedirectionPath } from "./router-redirections.helper";

export const useGetRedirectionPath = (routes: RedirectionRoute[]) => {
  const location = useLocation();
  const redirectPath = getRedirectionPath(routes, location.pathname);

  if (!redirectPath) return undefined;

  return redirectPath + location.search + location.hash;
};
